import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';

import { authenticationApi, backendApi } from 'src/api';
import { accountSliceReducer } from 'src/state/account/account-slice';
import { addressSliceReducer } from 'src/state/address/address-slice';
import { authSliceReducer } from 'src/state/auth/auth-slice';
import { cartSliceReducer } from 'src/state/cart/cart-slice';
import { orderSliceReducer } from 'src/state/order/order-slice';

import { authPersistConfig } from './auth/persist-config';

export const rootReducer = combineReducers({
  account: accountSliceReducer,
  address: addressSliceReducer,
  auth: persistReducer(authPersistConfig, authSliceReducer),
  cart: cartSliceReducer,
  order: orderSliceReducer,
  [backendApi.reducerPath]: backendApi.reducer,
  [authenticationApi.reducerPath]: authenticationApi.reducer,
});
